export default "__VITE_ASSET__CLJfMHN9__"